var map = {
	"./1.png": "c462",
	"./baki-logo.png": "5ff0",
	"./bay-logo.png": "8cda",
	"./bbl-logo.png": "9fa0",
	"./betded-logo.png": "f4ba",
	"./gsb-logo.png": "9014",
	"./kaiju-2.png": "8398",
	"./kbank-logo.png": "bd71",
	"./ktb-logo.png": "776a",
	"./logo-1.png": "321e",
	"./logo.png": "a4ef",
	"./logo.svg": "ed29",
	"./scb-logo.png": "6aa2",
	"./ttb-logo.png": "5c4f",
	"./vuexy-logo.png": "d120"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d47a";